import * as React from 'react';
import Modal from 'react-responsive-modal';
import { Order, BatData } from './iMonCompte';
import {getHostApi, getRequestConfig} from '../../utils';
import {getUserId, sessionExpire} from './MonCompteAction';
import axios from "axios";
import {Embrodery} from "./bat/Embrodery";
import {getFile} from "./upload/UploadActions.api";

interface RenderBatBySurfaceEmplacementState {
  openPreview: boolean;
  openBat: boolean;
  fileRegisteredId?: number;
  dimensions?: {largeur: number, hauteur: number};
  surfaceId: string;
  emplacementId: string;
}

interface RenderBatBySurfaceEmplacementProps {
  order: Order;
  data: BatData;
  index: number;
  isBatAuto?: boolean;
  activateBatAutoBroderieAffichageClient?: boolean;
}

export default class RenderBatBySurfaceEmplacement extends React.Component<RenderBatBySurfaceEmplacementProps,
  RenderBatBySurfaceEmplacementState> {
  constructor(props: RenderBatBySurfaceEmplacementProps) {
    super(props);
    this.state = {
      openPreview: false,
      openBat: false,
      surfaceId: this.props.data.surface_id[this.props.index],
      emplacementId: this.props.data.emplacement_id[this.props.index]
    };
  }

  componentDidMount() {
    if(this.props.isBatAuto) {
      this._getFile(this.props.data.idCaddies);
    }
  }

  _encode_utf8(texte: string) {
    return unescape(encodeURIComponent(texte));
  }

  onOpenModal = (type: string) => {
    if (type === 'bat') {
      this.setState({ openBat: true });
    } else {
      this.setState({ openPreview: true });
    }
  }

  onCloseModal = () => {
    this.setState({ openPreview: false, openBat: false });
  }

  _defineLinkImage = (type: string = 'miniatureTiff') => {
    if(type === "bat" && this.props.data.marquage === "broderie" && this.props.activateBatAutoBroderieAffichageClient && this.props.data.broderie[parseInt(this.props.data.idCaddies)][this.props.data.surfacesId[this.props.index]][0]?.fichierBroderiePrincipal) {
      const routeMiniatureFils = `${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/image-files?numCommande=${this.props.order.numCommande}&path=travail.auto/embroidery/&validated=true&xsrf=${localStorage.getItem('xsrfToken')}&cache=${Date.now()}&idCaddies=${this.props.data.idCaddies}`;
      return `${routeMiniatureFils}&nom=${this.props.data.broderie[parseInt(this.props.data.idCaddies)][this.props.data.surfacesId[this.props.index]][0].fichierBroderiePrincipal}`;
    }
    return getHostApi() + '/customers/' + getUserId() + '/orders/' + this.props.order.idCommande +
      '/image-files3?numCommande=' + this.props.order.numCommande + '&id=' + this.props.data.creation_id + '&num=' +
      this.props.data.surfacesId[this.props.index] + '&cyan=' +  this.props.data.cyan + '&magenta=' +
      this.props.data.magenta + '&jaune=' + this.props.data.jaune + '&noir=' + this.props.data.noir + '&picto=' +
      this.props.data.picto + '&emplacement=' + this.props.data.emplacements[this.props.index].split(' ').join('') +
      '&type='+type+'&idCaddies='+this.props.data.idCaddies+'&xsrf=' + localStorage.getItem('xsrfToken');

   /* return '/www/MonCompte/get-fichier3.php?numCommande=' + this.props.order.numCommande + '&id=' +
      this.props.data.creation_id + '&num=' + this.props.data.surfacesId[this.props.index] + '&cyan=' +
      this.props.data.cyan + '&magenta=' + this.props.data.magenta + '&jaune=' + this.props.data.jaune + '&noir=' +
      this.props.data.noir + '&picto=' + this.props.data.picto + '&emplacement=' +
      this.props.data.emplacements[this.props.index] + '&type=';*/
  }

  _getFile = (idCaddies: string) => {
    getFile(this.props.order.idCommande, idCaddies,this.state.surfaceId, this.state.emplacementId ).then((response: any) => {
      if (response && response.data.files) {
        this.setState({
          fileRegisteredId: response.data.files.id
        }, () => {
          this._getDimensionsBatAuto(idCaddies);
        });
      }
    });
  }

  _getDimensionsBatAuto = (idCaddies: string) => {
    if (this.state.fileRegisteredId) {
      axios.get(`${getHostApi()}/customers/${getUserId()}/orders/${this.props.order.idCommande}/items/${idCaddies}/surfaces/${this.state.surfaceId}/locations/${this.state.emplacementId}/images-bat-auto/${this.state.fileRegisteredId}/dimensions-surface`,
        getRequestConfig()).then((response) => {
        if (response.data) {
          this.setState({ dimensions: response.data.dimensions.surface});
        }
      }).catch((error) => {
        if (error.response.status === 401) { sessionExpire(); }
      });
    }
  }

  render() {
    let bgColor = `#${this.props.data.code1}`;
    if(this.props.data.cmjnData[this.props.data.surfacesId[this.props.index]].isPersonnalise) {
      bgColor = `#${this.props.data.cmjnData[this.props.data.surfacesId[this.props.index]].hexadecimal}`;
    }
    const renderModal = (type: string) => {
      let open = this.state.openPreview;
      if (type === 'bat') {
        open = this.state.openBat;
      }

      const styleBg =  type === 'bat' && this.props.isBatAuto ? {background: bgColor, padding: '5px',  maxHeight: '740px', maxWidth: '900px'  } : { maxHeight: '740px', maxWidth: '900px', background: bgColor };
      return (
        <Modal open={open} onClose={this.onCloseModal} center
               classNames={{overlay: 'bootstrap-container', modal: 'zoomBatModalContainer customModal',
                 closeButton: 'zoomBatModalCloseButton closeButton'}}>
          <div className="p-2" style={{ maxHeight: '760px' }}>
            <div className="text-center">
              {this.props.data.marquage === 'broderie' && type === 'preview' && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
                <span>Maquette de positionnement</span></div>}
              <img  style={styleBg} src={this._defineLinkImage(type)}
                    className="m-1" />
              {this.props.data.marquage === 'broderie' && type === 'preview' && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
                <span>Maquette de positionnement</span></div>}
            </div>
          </div>
        </Modal>
      );
    };

    const renderImage = (type: string) => {

      let strLargeur = null;
      let strHauteur = null;
      if(this.state.dimensions && this.props.isBatAuto) {
        strLargeur = this.state.dimensions && this.state.dimensions.largeur && this.state.dimensions.largeur > 0 ? this.state.dimensions.largeur.toFixed(2).replace('.', ',') : null;
        strHauteur = this.state.dimensions && this.state.dimensions.hauteur &&  this.state.dimensions.hauteur > 0 ? this.state.dimensions.hauteur.toFixed(2).replace('.', ',') : null;
      }
      if ((type === 'preview') || type === 'bat') {
        const defineAlt = () => {
          if (type === 'bat') { return 'BAT'; }
          return 'Prévisualisation';
        };
        const styleBg =  type === 'bat' && this.props.isBatAuto ? {background: bgColor, padding: '5px' } : {background: bgColor};
        return (
          <div onClick={e => this.onOpenModal(type)} className={'cursor-pointer flex-grow-1  position-relative'} >
            <img style={styleBg} src={this._defineLinkImage(type)} className={'mes-bat-' + type + ' mes-bat-picto-' + this.props.data.picto}
                 alt={defineAlt() + ' ' + this.props.data.Titre + ' ' +
                 this.props.data.surfaces[this.props.index] + ' ' + this.props.data.emplacements[this.props.index]} />
            {strLargeur && strHauteur && type === 'bat' && this.state.dimensions && this.props.isBatAuto &&
              <div className={'bg-white black text-center'}  style={{ border: '1px solid #dee2e6', width: '100%', marginTop: '0.5em'}}><span className={'px-1'}>{strLargeur}cm x {strHauteur}cm</span></div>
            }
            {this.props.data.marquage === 'broderie' && type === 'preview' && <div className="bg-white black text-center small" style={{border: "1px solid rgb(222, 226, 230)", width: "100%"}}>
              <span>Maquette de positionnement</span></div>}
          </div>
        );
      }
    };

    const renderPositionName = () => {
      return (
        <div className="border text-uppercase bold p-2 mt-2 black">
          {this.props.data.surfaces[this.props.index] + ' ' + this.props.data.emplacements[this.props.index]}
        </div>
      );
    };

    const renderPosition = () => {
      const isModel3d = this.props.data.isModel3d;

      return (
        <div className="positionBatContainer">
          <div className={'d-flex align-items-center justify-content-between flex-column positionBat flex-wrap'}>
            {!isModel3d && renderImage('preview')}
            {!isModel3d && renderModal('preview')}
            {renderImage('bat')}
            {renderModal('bat')}
            {this.props.data.marquage === "broderie" && this.props.isBatAuto && this.props.activateBatAutoBroderieAffichageClient && <Embrodery data={{...this.props.data, ...this.props.order}} idCaddies={parseInt(this.props.data.idCaddies)} surfaceEmplacementId={this.props.data.surfacesId[this.props.index]}/>}
          </div>
          {renderPositionName()}
        </div>
      );
    };

    return renderPosition();
  }
}
